function Badge({ children }: { children: string}) {
  return (
    <span className="inline-flex items-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 inset-ring inset-ring-blue-700/10 my-2">
      {children}
    </span>
  );
}

export default Badge;
